<template>
    <div>
        <!-- filters -->
        <v-row class="mt-0">
            <!-- type -->
            <v-col
            	cols="12"
            	md="2"
            	sm="3"
            	align-self="center"
            	class="pe-1 pb-1"
                :class="{
    				'py-0': $vuetify.breakpoint.lgAndUp
    			}"
            >
                <v-autocomplete
                    v-model.number="typeAccount"
                    :items="type"
                    item-text="name"
                    item-value="accountId"
                    :label="$t('inputs.type')"
                    outlined
                    dense
                    hide-details="auto"
                    @change="getName()"
                    :loading="loading"
                    :disabled="submitLoading || loading || !resetAllFilter"
                    prepend-icon="mdi-account-tie"
                    clearable
                />
            </v-col>

            <!-- employee -->
			<v-col 
				cols="12" 
				lg="2" 
				md="3" 
				sm="4" 
				align-self="center" 
                class="pa-1 pb-1"
				:class="{
    				'py-0': $vuetify.breakpoint.lgAndUp
    			}"
			>
                <v-autocomplete
                    v-model="name"
                    :items="typeAccount !== null ? names : []"
                    item-text="name"
                    item-value="accountId"
                    :label="$t('inputs.name')"
                    outlined
                    dense
                    hide-details
                    :loading="loading || submitLoading"
                    :disabled="submitLoading || loading"
                    clearable
               />
            </v-col>

            <!-- material -->
            <v-col
            	cols="12"
            	sm="4"
            	md="3"
            	lg="2"
            	align-self="center"
                class="pa-1 pb-1"
            >
                <v-autocomplete
                    v-model="item"
                    :label="$t('inputs.product-name')"
                    :items="materials"
                    item-text="name"
                    item-value="id"
                    outlined
                    dense
                    hide-details
                    :loading="loading"
                    :disabled="submitLoading || loading"
                    clearable
                />
            </v-col>

            <!-- start date -->
            <v-col
            	cols="12"
            	lg="2"
            	md="3"
            	sm="4"
            	align-self="center"
            	class="pa-1 pb-1"
            >
                <bee-date-picker
                    v-model="startDate"
                    menu-picker
                    dense
                    hide-details
                    :input-props="{
                        dense: true,
                        outlined: true,
                        prependIcon: 'mdi-calendar'
                    }"
                    :input-label="$t('inputs.start-date')"
                    :loading="loading"
                    :disabled="submitLoading || loading"
                    :allowed-dates="disableDates"
                ></bee-date-picker>
            </v-col>

            <!-- end date -->
            <v-col cols="12" lg="2" md="3" sm="4" align-self="center" class="pa-1 pb-1">
                <bee-date-picker
                    v-model="endDate"
                    menu-picker
                    dense
                    hide-details
                    :input-props="{
                        dense: true,
                        outlined: true,
                        prependIcon: 'mdi-calendar',
                        loading: loading
                    }"
                    :input-label="$t('inputs.end-date')"
                    :disabled="submitLoading || loading"
                    :allowed-dates="disableDates"
                ></bee-date-picker>
            </v-col>

            <!-- Pharmaceutical form -->
            <v-col v-if="0" cols="12" md="3" sm="4" align-self="center" class="pa-1 pb-1">
                <v-autocomplete
                    :items="materialForms"
                    item-text="name"
                    item-value="id"
                    :label="$t('inputs.pharmaceutical-form')"
                    dense
                    outlined
                    hide-details
                    :return-object="false"
                    clearable
                />
            </v-col>

            <v-col class="d-flex pb-1" align-self="center">
                <v-checkbox
                    v-model.number="isIn"
                    :label="$t('SamplesStatement.input')"
                    class="mt-0"
                    hide-details
                ></v-checkbox>
                <v-checkbox
                    v-model.number="isOut"
                    :label="$t('SamplesStatement.output')"
                    class="mt-0 ms-2"
                    hide-details
                ></v-checkbox>
                <!-- <v-radio-group
                    v-model.number="isInOrOut"
                    row
                    hide-details
                    class="mt-0"
                    :disabled="loading"
                >
                    <v-radio
                        label="Input"
                        :value="0"
                    ></v-radio>
                    <v-radio
                        label="Output"
                        :value="1"
                    ></v-radio>
                </v-radio-group> -->
            </v-col>

			<v-col class="d-flex py-0 justify-start" align-self="center" >
				<v-btn
					color="success"
					small
					class="mx-2"
                    :loading="loading"
                    :disabled="submitLoading || loading || isAllFieldsEmpty"
                    @click="resetAllFilter = false;needToResetItems = true; fetchAll();"
				>
					{{$t('search')}}
				</v-btn>

				<v-btn
					color="alert-color white--text"
					small
                    :loading="loading"
                    :disabled="submitLoading || loading"
                    @click="needToResetItems = true; reset(); fetchAll()"
				>
                    {{$t('reset')}}
				</v-btn>

                <v-btn
                    v-if="excelFile"
                    small
                    color="green lighten-1 white--text"
                    @click="importExcel"
                    class="mx-1"
                    :loading="loadingExcel"
                    :disabled="loadingExcel"
                >
                    <v-icon> mdi-file-table-outline </v-icon>
                    {{$t('export-excel')}}
                </v-btn>
            </v-col>

            <!-- <v-col class="d-flex  justify-end">
                <v-spacer />
                <v-btn @click="print()" small color="success">
                    <v-icon> mdi-print </v-icon>
                    {{$t('print')}}
                </v-btn>
            </v-col> -->
        </v-row>
        <div
            v-if="resetAllFilter"
            class="d-flex flex-column justify-center align-center"
            :style="{ height: !addPrice ? `${$vuetify.breakpoint.height - 90}px` : `${$vuetify.breakpoint.height - 211}px`}"
        >
            <v-progress-circular
                v-if="loading"
                color="primary"
                indeterminate
                size="44"
                width="4"
            />
            <template v-else>
                <v-icon size="60" class="mb-1">mdi-invoice-list</v-icon>
                <span class="text-h6">{{$t('SamplesStatement.please-select-a-filter')}}</span>
            </template>
        </div>

        <!-- dialogColumn -->
        <v-dialog v-model="dialogColumn" width="800">
            <v-card>
                <v-card-title class="d-flex justify-end background-title-card mb-3 py-1">
                    <div class="flex-grow-1 text-center text-uppercase text-body-2 py-0 white--text">
                        {{$t('SamplesStatement.hide-show-column')}}
                    </div>
            
                    <!-- close icon button -->
                    <v-btn icon @click="dialogColumn = false">
                        <v-icon color="white" >
                            mdi-close-circle-outline
                        </v-icon>
                    </v-btn>
                </v-card-title>
                <v-card-text >
                    <v-row>
                        <v-col cols="12">
                            <div class="container-card d-flex">
                                <draggable v-model="headers" class="drag-area d-flex flex-wrap" :options="{ animation: 200 }">
                                    <div v-for="(card, index) in headers" :key="index" class="card-in-statement d-flex flex-column justify-center align-center   ">
                                        <!-- <v-checkbox
                                            v-model="selectedHeaders"
                                            :value="card.value"
                                            hide-details
                                            class="mt-0"
                                        ></v-checkbox> -->
                                            <!-- v-model="selectedHeaders" -->
                                        <span style="width: 100%;" class="text-start">
                                            {{ index + 1 }}
                                        </span>
                                        <!-- <v-switch
                                            v-model="card.isShow"
                                            hide-details
                                            class="mt-0"
                                        /> -->

                                        <v-btn icon @click="card.isShow = !card.isShow">
                                            <v-icon :color="card.isShow ? 'success' :  '' "> {{ card.isShow ? 'mdi-eye' : 'mdi-eye-off' }} </v-icon>
                                        </v-btn>
                                        <span>
                                            {{ card.text }}
                                        </span>
                                    </div>
                                </draggable>
                            </div>
                        </v-col>
                        <!-- <v-col align-self="center" v-for="(header, index) in allHeaders" :key="index" cols="6" class="py-1">
                            <v-checkbox
                                v-model="selectedHeaders"
                                :label="header.text"
                                :value="header.value"
                                hide-details
                                class="mt-0"
                            ></v-checkbox>
                        </v-col> -->
                    </v-row>
                </v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <v-btn color="success" @click="applyColumnChanges()">
                        {{$t('SamplesStatement.apply')}}
                    </v-btn>
                </v-card-actions>
            </v-card>   
        </v-dialog>

		<!-- table -->
		<bee-handy-table
            v-if="!resetAllFilter"
            ref="table"
			:items="[]"
			:headers="tableHeaders"
			dense
			zebra
			class="mt-6"
            hide-default-footer
            :loading="loading"
            :height="addPrice ? $vuetify.breakpoint.height - (40 + 35 + 80 + 48 + 50 + 20) : $vuetify.breakpoint.height - (40 + 35 + 80)"
            fixed-header
            pagination-on-scroll
            :pagination-on-scroll-auto-reset-shown="false"
            pagination-on-scroll-server-items
            :items-per-page="20"
            :scroll-options.sync="scrollOptions"
            :server-items-length="serverItemsLength"
            @pagination-on-scroll:reach-last-row="fetchAll"
            :shown-rows-text="$t('shown-rows')"
		>
            <template v-slot:item.materialId="{ item }">
                {{ getMaterialById(item.materialId)?.name }}
            </template>
            <template v-slot:item.sellPrice="{ item }">
                {{ item.in ? item.in.sellPrice !== null ? item.in.sellPrice : '-' : item.out.sellPrice !== null ? item.out.sellPrice : '-' }}
            </template>

            <template v-slot:item.accountId="{ item }">
                {{   
                    typeAccount === 1 
                        ? customers.find(c => c.accountId === item.accountId)?.name 
                        : staff.find(c => c.accountId === item.accountId)?.name 
                }}
            </template>

            <template v-slot:item.in="{ item }">
                {{
                    item.in !== null ? item.in.amount : '-'
                }}
            </template>

            <template v-slot:item.out="{ item }">
                {{
                    item.out !== null ? item.out.amount : '-'
                }}
            </template>

            <template v-slot:item.priceTypeId="{ item }">
                {{ 
                    item.priceTypeId ? pricesTypes.find(c => c.id === item.priceTypeId)?.name : '-'
                }}
            </template>

            <template v-slot:item.description="{ item }">
                {{
                    item.description ? item.description.includes('Transaction from visit') ? '- ' : val : '-'
                }}
            </template>

            <template v-slot:item.notes="{ item }">
                {{
                    item.notes ? item.notes.includes('Transaction from visit') : ' '
                }}
            </template>

            <template v-slot:item.notes="{ item }">
				<v-icon 
					v-if="item.description && item.description.includes('Transaction from visit')" 
					color="success"
				> 
					mdi-check-circle 
				</v-icon>
				<v-icon 
					v-else
					color="alert-color"
				> 
					mdi-close-circle 
				</v-icon>
			</template>

            <template v-slot:top>
                <div class="text-none d-flex justify-end">
                    <v-btn small @click="dialogColumn = true" class="text-none d-flex justify-end"> Hide / show column </v-btn>
                </div>
            </template>
        </bee-handy-table>

        <!-- footer -->
        <v-footer v-if="addPrice && !resetAllFilter " color="grey lighten-3" padless>
            <v-col
                class="text-center"
                cols="12"
            >
                {{ $t('SamplesStatement.total-sales') }} : <strong> {{ totalSales ? totalSales : 0 }} </strong>
            </v-col>
        </v-footer>
    </div>
</template>

<script>
import moment from 'moment'
import { mapGetters, mapState } from 'vuex'
import { excelFile, addPrice, isDisabledFriday, enablePricesTypes } from '@/configs/global.config'
import { disableDates } from '@/helpers/functions'
import draggable from 'vuedraggable'
export default {
    components: {
        draggable,
    },
    watch: {
        isOut(val) {
            if (val === true) {
                this.isIn = false
            }
        },
        isIn(val) {
            if (val === true) {
                this.isOut = false
            }
        },

        // dialogColumn (val) {
        //     if (!val) {
        //         this.testMethods()
        //     }
        //     // if (val) {
        //     //     if ('headersWithColumn' in localStorage) {
        //     //         this.selectedHeaders = JSON.parse(localStorage.getItem('headersWithColumn')).map(c => c.isShow === true ? c.value : null).filter(f => f !== null)
        //     //     } else {
        //     //         this.selectedHeaders.push(...this.headers.map(c => c.isShow === true ? c.value : null))
        //     //     }
        //     // }
        // }
    },
    data () {
        return {
            excelFile,
            loading: false,
            loadingExcel: false,
            resetAllFilter: true,
            items: [],
			entities: [],
            item: null,
            startDate: null,
            endDate: null,
            name: null,
            typeAccount: null,
            names: [],
            submitLoading: false,
            summary: [],
            needToResetItems: false,
            scrollOptions: {},
            serverItemsLength: 0,
            // isInOrOut: null,
            isIn: null,
            isOut: null,
            addPrice,
            totalSales: 0,
            isDisabledFriday,
            disableDates,
            enablePricesTypes,
            dialogColumn: false,
            selectedHeaders: [],
            headers: [
                {
                    text: this.$t('headers.account'),
                    name: 'accountId',
                    value: 'accountId',
                    sortable: false,
                    isShow: true
                },
                {
                    text: this.$t('headers.input-quantity'),
                    name: 'in',
                    value: 'in',
                    sortable: false,
                    isShow: true
                },
                {
                    text: this.$t('headers.output-quantity'),
                    name: 'out',
                    value: 'out',
                    sortable: false,
                    isShow: true
                },
                // new column
                {
                    text: this.$t('headers.remaining-quantity'),
                    name: 'remaining-quantity',
                    value: 'amountRemaining',
                    sortable: false,
                    isShow: true
                },
                {
                    text: this.$t('headers.sell-price'),
                    name: 'sellPrice',
                    value: 'sellPrice',
                    noNotAvailableText: true,
                    sortable: false,
                    isShow: true
                },
                {
                    text: this.$t('headers.price-type'),
                    name: 'priceTypeId',
                    value: 'priceTypeId',
                    noNotAvailableText: true,
                    sortable: false,
                    isShow: false
                },
                {
                    text: this.$t('headers.discount'),
                    name: 'priceDiscount',
                    value: 'priceDiscount',
                    noNotAvailableText: true,
                    sortable: false,
                    isShow: false
                },
                {
                    text: this.$t('headers.from-to-account'),
                    name: 'fromToAccountName',
                    value: 'fromToAccountName',
                    sortable: false,
                    isShow: true
                },
                {
                    text: this.$t('headers.notes'),
                    name: 'description',
                    value: 'description',
                    sortable: false,
                    isShow: true
                },
                {
                    text: this.$t('headers.transaction-from-visit'),
                    name: 'notes',
                    value: 'notes',
                    type: 'string',
					noInput: true,
					sortable: false,
                    isShow: true
                },
                {
                    text: this.$t('headers.material'),
                    name: 'materialId',
                    value: 'materialId',
                    sortable: false,
                    isShow: true
                },
                {
                    text: this.$t('headers.date'),
                    name: 'date',
                    value: 'date',
                    setValueExpr: val => moment(val).format('YYYY-MM-DD'),
                    sortable: false,
                    isShow: true
                }
            ]
        }
    },

    computed: {
        tableHeaders() {
            // if ('headersWithColumn' in localStorage) {
            //     return JSON.parse(localStorage.getItem('headersWithColumn')).filter(header => header.isShow === true)
            // } else {
            //     return this.headers.filter(header => header.isShow === true)
            // }
            return this.headers.filter(h => h.isShow)
        },

        ...mapState({ 
            materials: state => state.materials.materials,
            materialForms: state => state.materialForms.materialForms,
            supervisors: state => state.supervisors.supervisors,
            medicalRepsBrief: state => state.medicalreps.medicalRepsBrief,
            isSuperAdmin: state => state.auth.isSuperAdmin,
            accounts: state => state.accounts.accounts,
            staff: state => state.accounts.staff,
            customers: state => state.accounts.customers,
            pricesTypes: state => state.pricesTypes.pricesTypes
        }),

        ...mapGetters({
            isAdmin: 'auth/isAdmin',
            getMaterialById: 'materials/getMaterialById',
            getAccountById: 'accounts/getAccountById'
        }),

        isAllFieldsEmpty(){
            return this.typeAccount === null && this.name === null && this.item === null && this.startDate === null && this.endDate === null;
        },

        type() {
            return [
				{ accountId: 1, name: this.$t('SamplesStatement.customers'), },
				// { accountId: 2, name: this.$t('SamplesStatement.external-entities'), },
				{ accountId: 0, name: this.$t('SamplesStatement.staff'), }
			]
        },

        allHeaders() {     
            const headers = [
                {
                    text: this.$t('headers.account'),
                    name: 'accountId',
                    value: 'accountId',
                    setValueExpr: val => val 
                        ? this.typeAccount === 1 
                            ? this.customers.find(c => c.accountId === val)?.name 
                        : this.staff.find(c => c.accountId === val)?.name 
                            : '-',
                    sortable: false,
                    isShow: true
                },
                {
                    text: this.$t('headers.input-quantity'),
                    name: 'Input-quantity',
                    value: 'in',
                    setValueExpr: val => val !== null ? val.amount : '-',
                    sortable: false,
                    isShow: true
                },
                {
                    text: this.$t('headers.output-quantity'),
                    name: 'output-quantity',
                    value: 'out',
                    setValueExpr: val => val !== null ? val.amount : '-',
                    sortable: false,
                    isShow: true
                },
                // new column
                {
                    text: this.$t('headers.remaining-quantity'),
                    name: 'remaining-quantity',
                    value: 'amountRemaining',
                    sortable: false,
                    isShow: true
                },
                {
                    text: this.$t('headers.sell-price'),
                    name: 'sellPrice',
                    value: 'sellPrice',
                    noNotAvailableText: true,
                    sortable: false,
                    isShow: true
                }, 

                {
                    text: this.$t('headers.price-type'),
                    name: 'priceTypeId',
                    value: 'priceTypeId',
                    // setValueExpr: val => val ? this.pricesTypes.find(c => c.id === val)?.name : '-',
                    noNotAvailableText: true,
                    sortable: false,
                    isShow: false
                },
                {
                    text: this.$t('headers.discount'),
                    name: 'priceDiscount',
                    value: 'priceDiscount',
                    noNotAvailableText: true,
                    sortable: false,
                    isShow: false
                },
                {
                    text: this.$t('headers.from-to-account'),
                    name: 'fromToAccountName',
                    value: 'fromToAccountName',
                    sortable: false,
                    isShow: true
                },
                {
                    text: this.$t('headers.notes'),
                    name: 'description',
                    value: 'description',
                    setValueExpr: val => val ? val.includes('Transaction from visit') ? '- ' : val : '-',
                    sortable: false,
                    isShow: true
                },
                {
                    text: this.$t('headers.transaction-from-visit'),
                    name: 'notes',
                    value: 'notes',
					setValueExpr: val => val ? val.includes('Transaction from visit') : ' ',
                    type: 'string',
					noInput: true,
					sortable: false,
                    isShow: true
                },
                {
                    text: this.$t('headers.material'),
                    name: 'material',
                    value: 'materialId',
                    setValueExpr: val => this.getMaterialById(val)?.name,
                    sortable: false,
                    isShow: true
                },
                {
                    text: this.$t('headers.date'),
                    name: 'date',
                    value: 'date',
                    setValueExpr: val => moment(val).format('YYYY-MM-DD'),
                    sortable: false,
                    isShow: true
                }
                // {
                //     text: 'Sort column',
                //     name: 'sort-column',
                //     value: 'sort-column'
                // }
            ]
            return headers
        },
        inOrOut() {
            let isInOrOut = null
            if (this.isIn === false && this.isOut === false) {
                isInOrOut = null
            } else if (this.isIn === false && this.isOut === true) {
                isInOrOut = false
            } else if (this.isIn === true && this.isOut === false) {
                isInOrOut = true
            }
            return isInOrOut
        }
    },

	methods: {	
        moment,
        importExcel() {
            this.loadingExcel = true
            this.$store.dispatch('exporter/fetchStatementExport', { MaterialId: this.item, FromDate: this.startDate, ToDate: this.endDate, AccountId: this.name, Type: this.typeAccount }).finally(() => {
                this.loadingExcel = false
            })
        },
        reset() {
            this.item = null
            this.startDate = null
            this.endDate = null
            this.name = null
            this.typeAccount = null
            this.resetAllFilter = true
        },

        getName() {
            if (this.typeAccount === 0 && this.staff.length !== 0) {
                this.names = this.staff
            } else if (this.typeAccount === 1 && this.customers.length !== 0) {
                this.names = this.customers
            } else {
                // this.submitLoading = true
                // this.$store.dispatch('accounts/fetchAllBrief', { type: this.typeAccount, regionIds: [] }).then((data) => {
                //     this.names = data   
                //     this.submitLoading = false
                // }).finally(() => {
                //     this.submitLoading = false
                // })
            }
        },

        fetchAll(newOptionsScroll) {
            this.loading = true;
            let page = 1;

            const { itemsPerPage } = this.scrollOptions;

            if (newOptionsScroll) {
                page = newOptionsScroll.page;
            }
            this.$store.dispatch('materialTransactions/fetchStatement', { 
                type: this.typeAccount,
                date: this.moment().format('YYYY-MM-DD'), 
                MaterialId: this.item, 
                FromDate: this.startDate, 
                ToDate: this.endDate, 
                AccountId: this.name, 
                Page: page, 
                PerPage: itemsPerPage,
                regionIds: [],
                isInput: this.inOrOut
            }).then(({ data, total }) => {
                // if (data.length) {
                if (this.needToResetItems) { 
                    this.$refs.table.resetShownRows();
                    this.needToResetItems = false;
                }
                const entities = data.map(c => ({ 
                    ...c, 
                    materialId: c.in ? c.in.materialId : c.out.materialId
                }));
                this.$refs.table.addScrollItems(entities)
                this.entities = entities
                this.serverItemsLength = total;
                this.totalSales = this.addPrice ? data[0].totalSales : 0
                // }
            }).finally(() => {
                this.loading = false;
            })
        },

        applyColumnChanges() {
            localStorage.setItem('headersWithColumn', JSON.stringify(this.headers))
            this.dialogColumn = false
        },
    },  

    created () {
        // for headers with column sort or hide / show
        const savedHeaders = localStorage.getItem('headersWithColumn')
        if (savedHeaders) {
            const headers = JSON.parse(savedHeaders)
            this.headers.forEach(h => {
                const saved = headers.find(s => s.value === h.value)
                if (saved) {
                    h.isShow = saved.isShow
                }
            })
            this.headers.sort((a, b) => {
                const aIndex = headers.findIndex(s => s.value === a.value)
                const bIndex = headers.findIndex(s => s.value === b.value)
                return aIndex - bIndex
            })
        }
        this.loading = true
        Promise.all([
            !this.materials.length ? this.$requestStack.setRequest({
                key: 'materials/fetchAll',
                promise: this.$store.dispatch('materials/fetchAll', true)
            }) : this.$requestStack.getRequest('materials/fetchAll').promise,

            this.$store.dispatch('materialForms/fetchAll'),
            
            !this.medicalRepsBrief.length ? this.$requestStack.setRequest({
                key: 'medicalreps/fetchAllBrief',
                promise: this.$store.dispatch('medicalreps/fetchAllBrief', true)
            }) : this.$requestStack.getRequest('medicalreps/fetchAllBrief').promise,

            // !this.staff.length ? this.$store.dispatch('accounts/fetchAllBrief', { type: 0, includeAddress: true, regionIds: [] }) : null,
            // !this.customers.length ? this.$store.dispatch('accounts/fetchAllBrief', { type: 1, includeAddress: true, regionIds: [] }) : null,
            !this.staff.length ? this.$requestStack.setRequest({
                key: 'accounts/fetchAllBrief/2',
                promise: this.$store.dispatch('accounts/fetchAllBrief', { type: 0, includeAddress: true, regionIds: [] }),
            }) : this.$requestStack.getRequest('accounts/fetchAllBrief/2').promise,

            !this.customers.length
                ? this.$requestStack.setRequest({
                    key: 'accounts/fetchAllBrief/1',
                    promise: this.$store.dispatch('accounts/fetchAllBrief', { type: 1, includeAddress: true, regionIds: [] })
                })
                : this.$requestStack.getRequest('accounts/fetchAllBrief/1').promise,
            this.enablePricesTypes && !this.pricesTypes.length ? this.$store.dispatch('pricesTypes/fetchAll') : null,
        ]).then(() => {
            // this.fetchAll()
        }).finally(() => {
            this.loading = false
        })
    } 

}
</script>

<style>
.container-card-card {
    display: flex; /* استخدام الفليكس لجعل البطاقات بجانب بعضها */
    flex-wrap: wrap; /* للسماح بتغليف البطاقات في صفوف */
    /* gap: 10px; المسافة بين البطاقات */
}

.card-in-statement {
    background-color: #f9f9f9;
    border: 1px solid #ddd;
    border-radius: 5px;
    padding-bottom: 20px;
    padding-left: 10px;
    padding-right: 10px;
    width: 24%; /* عرض ثابت للبطاقات */
    height: auto;
    text-align: center;
    cursor: move; /* تغيير المؤشر عند السحب */
    display: flex;
    justify-content: center;
    align-content: center;
    margin: 3px;
}
</style>